import { useContext, useEffect, useState } from "react";
import SearchProvider from "../../Provider/SearchProvider";
import Spinder from "../../UI/Spiner/Spinder";
import { Breadcrumb, Button, Select } from "antd";
import DoctorCardNew from "../../UI/DoctorCard/DoctorCardNew";
import Meta from "../../Meta/Meta";
const Doctor = () => {
  const {
    getDoctorSearchData,
    doctorSearchLoader,
    getDoctorDataDropdown,
    setDoctorSearchLoader,
    doctorSearchData,
    setDoctorSearchData,
    doctorDropdown,
    setDoctorDropdown,
    // drop

    provinceDropdown,
    provinceLoaderDropdown,
    provinceListDropdown,
    selectedDropdown,
    setSelectedDropdown,
    // districtDropdown,
    districtDropdown,
    districtListDropdown,
    setDistrictListDropdown,
    districtLoaderDropdown,
    // secretariatDropdown,
    secretariatsDropdown,
    secretariatListDropdown,
    setSecretariatListDropdown,
    secretariatLoaderDropdown,
    setSecretariatLoaderDropdown,
    getSearchDataDropdown,
    searchLoaderDropdown,
    doctorSearchTable,
    setDoctorSearchTable,
  } = useContext(SearchProvider);
  useEffect(() => {
    getDoctorSearchData();
    provinceDropdown();
    setDoctorDropdown({
      province_id: "",
      district_id: "",
      secretariats_id: "",
    });
  }, []);

  useEffect(() => {
    getDoctorSearchData();
  }, [doctorSearchTable]);
  console.log("doctorSearchData", doctorSearchData);
  // console.log("doctorDropdown", doctorDropdown);

  return (
    <>
      <Meta slug={"doctors"} />
      <section className="my-[5vh]">
        {doctorSearchLoader ? (
          <Spinder />
        ) : (
          <div className="container">
            <div className="my-[2rem] flex gap-[1rem] flex-wrap lg:flex-nowrap">
              <div className="flex items-center gap-[1rem]">
                <h3 className="font-normal text-[16px] text-lightgray">
                  Province
                </h3>
                <Select
                  size="large"
                  showSearch
                  value={doctorDropdown.province_id || null}
                  placeholder="Select a Province"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  loading={provinceLoaderDropdown}
                  options={provinceListDropdown}
                  onChange={(value) => {
                    setDoctorDropdown({
                      ...doctorDropdown,
                      province_id: value,
                      district_id: null,
                      secretariats_id: null,
                    });
                    setDistrictListDropdown([]);
                    setSecretariatListDropdown([]);
                    districtDropdown(value);
                  }}
                />
              </div>
              <div className="flex items-center gap-[1rem]">
                <h3 className="font-normal text-[16px] text-lightgray">
                  District
                </h3>
                <Select
                  showSearch
                  size="large"
                  value={doctorDropdown.district_id || null}
                  placeholder="Select a district"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  loading={districtLoaderDropdown}
                  options={districtListDropdown}
                  onChange={(value) => {
                    setDoctorDropdown({
                      ...doctorDropdown,
                      district_id: value,
                      secretariats_id: null,
                    });
                    setSecretariatListDropdown([]);
                    secretariatsDropdown(value);
                  }}
                />
              </div>
              <div className="flex items-center gap-[1rem]">
                <h3 className="font-normal text-[16px] text-lightgray">
                  Secretariat
                </h3>
                <Select
                  showSearch
                  size="large"
                  value={doctorDropdown.secretariats_id || null}
                  placeholder="Select a Secretariat"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={secretariatListDropdown}
                  loading={secretariatLoaderDropdown}
                  onChange={(value) => {
                    setDoctorDropdown({
                      ...doctorDropdown,
                      secretariats_id: value,
                    });
                  }}
                />
              </div>
              <Button
                size="large"
                type="primary"
                className="bg-[#268F81] text-white font-primary font-normal text-[16px] text-white text-center"
                onClick={() => getDoctorDataDropdown(doctorDropdown)}
              >
                Search
              </Button>
            </div>
            <Breadcrumb
              separator="/"
              items={[
                {
                  title: "Home",
                  href: "/",
                },
                {
                  title: `Doctors`,
                },
              ]}
            />
            {doctorSearchData?.data?.map((item, index) => (
              <DoctorCardNew key={index} doctorData={item} />
            ))}
            {doctorSearchData?.data?.length === 0 && (
              <h1 className="text-center font-primary text-[18px] my[2rem]">
                No Data Found
              </h1>
            )}
            {doctorSearchData?.data?.length > 0 && (
              <div className="flex gap-[1rem] justify-center mt-[2rem] ">
                <button
                  className={`cursor-pointer px-[1rem] py-[0.5rem] rounded-[5px] text-white bg-primary font-primary font-normal text-[1.5rem] hover:bg-white hover:text-primary transition-all duration-200 ${
                    doctorSearchTable?.page === 1
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  onClick={() => {
                    if (doctorSearchTable?.page > 1) {
                      setDoctorSearchTable((prev) => ({
                        ...prev,
                        page: prev.page - 1,
                      }));
                    }
                  }}
                  disabled={doctorSearchTable?.page === 1} // Disable button when page is 1
                >
                  Prev
                </button>
                <button
                  className={`px-[1rem] py-[0.5rem] rounded-[5px] text-white bg-primary font-primary font-normal text-[1.5rem]  hover:bg-white hover:text-primary transition-all duration-200 ${
                    doctorSearchTable?.page ===
                    Math.ceil(
                      doctorSearchData?.total / doctorSearchTable?.limit
                    )
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  onClick={() => {
                    // Increment the current page by 1
                    if (doctorSearchTable?.page !== null) {
                      const nextPage = doctorSearchTable?.page + 1;
                      setDoctorSearchTable({
                        ...doctorSearchTable,
                        page: nextPage,
                      });
                    }
                  }}
                >
                  {" "}
                  next
                </button>
              </div>
            )}
          </div>
        )}
      </section>
    </>
  );
};

export default Doctor;
